module.exports = __webpack_public_path__ + "img/privatespa.7b04be93.jpg";